export default "__VITE_ASSET__C3Hc7I01__"